<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div class="doc-paper preview rirekisho" :id="idPrefix + 'preview-page-01'">
      <div class="rirekisho-header">
        <div class="title" style="letter-spacing: normal">エントリーシート</div>
        <div
          class="date"
          @click="goCardTo('create-date')"
          :class="highLightClass('create-date')"
        >
          <span v-html="formatedCreateDate"></span> 現在
        </div>
      </div>
      <div class="flex">
        <div class="rirekisho-box1">
          <div
            class="rirekisho-profile"
            :data-highlight="highlightMessage"
            @click="goCardTo('profile')"
            :class="highLightClass('profile')"
          >
            <div class="ruby flex">
              <div class="label">ふりがな</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.lastNameFurigana }}&emsp;{{
                  basicData.firstNameFurigana
                }}
              </div>
            </div>
            <div class="name flex">
              <div class="label">名前</div>
              <div class="input" :style="formatData.selFontStyle">
                {{ basicData.lastName }}&emsp;{{ basicData.firstName }}
              </div>
            </div>
            <div
              class="etc flex"
              style="border-bottom: solid 1px #000; height: 30px"
            >
              <div class="birthday" :style="formatData.selFontStyle">
                <span class="year">{{ basicData.birthYear }}</span
                >年 <span class="month">{{ basicData.birthMonth }}</span
                >月 <span class="day">{{ basicData.birthDay }}</span
                >日生（満 <span class="age">{{ age }}</span> 歳）
              </div>
            </div>
          </div>
          <div
            class="contact-information-address"
            :data-highlight="highlightMessage"
            @click="goCardTo('address')"
            :class="highLightClass('address')"
            style="
              width: 100%;
              border-left: solid 2px rgb(0 0 0 / 75%);
              border-right: solid 2px rgb(0 0 0 / 75%);
              box-sizing: border-box;
            "
          >
            <div class="ruby flex">
              <div class="label">ふりがな</div>
              <div
                class="input"
                ref="addressFurigana"
                :class="classObject.addressFurigana"
                :style="formatData.selFontStyle"
              >
                {{ basicData.addressFurigana }}
              </div>
            </div>
            <div class="address flex">
              <div class="label">現住所</div>
              <div class="input">
                <div class="postal-code" :style="formatData.selFontStyle">
                  &#12306;{{
                    formLib.separatedPostNumber(basicData.postNumber)
                  }}
                </div>
                <pre :style="formatData.selFontStyle"
                  >{{ basicData.address1 }}{{ basicData.address2 }}</pre>
              </div>
            </div>
          </div>
        </div>
        <div
          class="rirekisho-photo"
          :data-highlight="highlightMessage"
          @click="goCardTo('id-photo')"
          :class="highLightClass('id-photo')"
        >
          <div v-if="basicData.idPhotoSrc">
            <img :src="basicData.idPhotoSrc" alt="証明写真" />
          </div>
          <div v-else>
            <div class="rirekisho-photo-inner">
              <p>
                証明写真 <br />縦 36mm&#12316;40mm <br />横 24mm&#12316;30mm
                <br />本人単身胸から上 <br />裏面のりづけ
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-box2" style="border-bottom: 0">
        <div class="email flex" style="height: 30px">
          <div
            class="label"
            style="align-self: center; padding-left: 2mm; width: 20mm"
          >
            Email
          </div>
          <div
            class="input"
            :style="formatData.selFontStyle"
            style="align-self: center"
          >
            {{ basicData.email }}
          </div>
        </div>
      </div>

      <div
        class="rirekisho-table rirekisho-new-history-1"
        :data-highlight="highlightMessage"
        @click="goCardTo('edu-history')"
        :class="highLightClass(['edu-history', 'job-history'])"
        style="margin-top: 0"
      >
        <table :class="{ error: errorMessages.eduJobHistory }">
          <thead>
            <tr>
              <th>年</th>
              <td>月</td>
              <td>学歴</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in eduJobHistoryTable4New.slice(0, 4)"
              v-bind:class="item.classObject"
              :key="index"
            >
              <th :style="formatData.selFontStyle">{{ item.year }}</th>
              <td :style="formatData.selFontStyle">{{ item.month }}</td>
              <td
                :class="{
                  'font-size-sm': formLib.charCount(item.description) > 68
                }"
                :style="formatData.selFontStyle"
              >
                {{ item.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--テキスト入力-->
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('study-history')"
        :class="highLightClass('study-history')"
        style="
          height: 80px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: 0;
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          ゼミ・<br />研究テーマ
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="studyHistory"
            :class="classObject.studyHistory"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.studyHistory }}</pre>
        </div>
      </div>
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('club-activity')"
        :class="highLightClass('club-activity')"
        style="
          height: 80px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: 0;
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          クラブ・<br />サークル
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="clubActivity"
            :class="classObject.clubActivity"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.clubActivity }}</pre>
        </div>
      </div>
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('license-history')"
        :class="highLightClass('license-history')"
        style="
          height: 35px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: 0;
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          保有資格
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="licenseHistory"
            :class="classObject.licenseHistory"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.licenseHistory }}</pre>
        </div>
      </div>
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('skill-list')"
        :class="highLightClass('skill-list')"
        style="
          height: 35px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: 0;
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          趣味・特技
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="skillList"
            :class="classObject.skillList"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.skillList }}</pre>
        </div>
      </div>
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('parttime-job')"
        :class="highLightClass('parttime-job')"
        style="
          height: 80px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: 0;
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          アルバイト<br />経験
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="parttimeJob"
            :class="classObject.parttimeJob"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.parttimeJob }}</pre>
        </div>
      </div>
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('reasonNew')"
        :class="highLightClass('reasonNew')"
        style="
          height: 80px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: 0;
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          自己PR
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="reasonNew"
            :class="classObject.reasonNew"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.reasonNew }}</pre>
        </div>
      </div>
      <div
        class="entrytxt flex"
        :data-highlight="highlightMessage"
        @click="goCardTo('reason')"
        :class="highLightClass('reason')"
        style="
          height: 80px;
          align-items: center;
          border: solid 2px rgb(0 0 0 / 75%);
          border-bottom: solid 2px rgb(0 0 0 / 75%);
        "
      >
        <div
          class="label"
          style="
            font-size: 12px;
            width: 98px;
            height: 80px;
            border-right: solid 1px #000;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          志望動機
        </div>
        <div class="input" style="width: calc(100% - 98px)">
          <pre
            ref="reason"
            :class="classObject.reason"
            :style="formatData.selFontStyle"
            style="margin: 5px"
            >{{ formatData.reason }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.entrytxt {
  &:hover {
    background: rgb(102 148 140 / 10%);
    transition: 0.5s;
  }
}
</style>

<script setup lang="ts">
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const {
  reason,
  reasonNew,
  addressFurigana,
  checkValid,
  formLib,
  scaleStyle,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  age,
  formatedCreateDate,
  eduJobHistoryTable4New,
  optionItems
} = useRirekishoPreview(props, {
  maxEduJobRows: 11,
  maxLicenseRows: 5,
  textareaMaxHeights: {
    reason: 70,
    reasonNew: 70,
    studyHistory: 70,
    clubActivity: 70,
    parttimeJob: 70,
    licenseHistory: 30,
    skillList: 30
  },
  useEduJobTable4New: true
})

defineExpose({
  checkValid,
  errorMessages,
  optionItems,
  reason,
  reasonNew,
  addressFurigana
})
</script>
